import DataGrid, { Column } from 'devextreme-react/data-grid';
import { GuarantorSummaryColumns } from '../../common/constants/tables/columns/GuarantorSummaryColumns';
import { BorrowerLendingLimitTableType } from '../../common/constants/tables/BorrowerLendingLimitTableType';
import { bllSharedCellStyling } from '../../common/constants/tables/cells/styles/bllSharedCellStyling';
import { currencyCellItemRender } from '../../common/constants/tables/cells/renders/currencyCellItemRender';
import { summaryItemTypeCellRender } from '../../common/constants/tables/cells/renders/summaryItemCellRender';
import { ILoanHistorySummaryTableRow } from '../../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { IGuarantorSummaryTableRow } from '../../common/constants/tables/interfaces/IGuarantorSummaryTableRow';

interface GuarantorSummaryTableProps {
    guarantorSummaryData: IGuarantorSummaryTableRow[] | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
}
export const GuarantorSummaryTable: React.FC<GuarantorSummaryTableProps> = ({ onLoanSummaryClick, guarantorSummaryData }) => {
    const columnSpecificCellStyling = (e) => {
        switch (e.column?.dataField) {
            case GuarantorSummaryColumns.RegBLLCapacity:
                e.cellElement.style.borderRight = '2px solid #000';
                e.cellElement.style.color = 'darkgreen';
                e.cellElement.style.setProperty('padding-right', '40px', 'important');
                break;
            case GuarantorSummaryColumns.MaxSurplus:
                e.cellElement.style.color = 'darkgreen';
                break;
            default:
                break;
        }
    };

    const prepareCells = (e) => {
        //Run shared styling
        bllSharedCellStyling(e);

        //Run table specific cell styling
        columnSpecificCellStyling(e);
    };

    return (
        <>
            <DataGrid
                dataSource={guarantorSummaryData}
                keyExpr='summaryItemType'
                showBorders={false}
                showRowLines={false}
                rowAlternationEnabled={true}
                remoteOperations={false}
                allowColumnReordering={true}
                allowColumnResizing={true}
                noDataText='No Guarantor Summary Available'
                onCellPrepared={(e) => {
                    prepareCells(e);
                }}
                style={{ padding: '10px' }}
            >
                <Column
                    dataField={GuarantorSummaryColumns.SummaryItemType}
                    caption=''
                    alignment={'left'}
                    width={160}
                    cellRender={(e) =>
                        summaryItemTypeCellRender(
                            e,
                            BorrowerLendingLimitTableType.GuarantorSummary,
                            GuarantorSummaryColumns.SummaryItemType
                        )
                    }
                />
                <Column
                    dataField={GuarantorSummaryColumns.BLL}
                    caption='BLL'
                    width={140}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.GuarantorSummary)}
                />
                <Column
                    dataField={GuarantorSummaryColumns.OutstandingAmount}
                    caption='Outstanding'
                    width={140}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.GuarantorSummary)}
                />
                <Column
                    dataField={GuarantorSummaryColumns.Surplus}
                    caption='Surplus'
                    width={140}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.GuarantorSummary)}
                />
                <Column
                    dataField={GuarantorSummaryColumns.RegBLLCapacity}
                    caption='Reg. BLL Capacity'
                    width={200}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.GuarantorSummary)}
                />
                <Column
                    dataField={GuarantorSummaryColumns.MaxSurplus}
                    caption='Max Surplus'
                    width={130}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.GuarantorSummary)}
                />
                <Column
                    dataField={GuarantorSummaryColumns.Total}
                    caption='Total'
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.GuarantorSummary)}
                />
            </DataGrid>
        </>
    );
};
